import { render, staticRenderFns } from "./BanksPage.vue?vue&type=template&id=211475cc&scoped=true&"
import script from "./BanksPage.vue?vue&type=script&lang=js&"
export * from "./BanksPage.vue?vue&type=script&lang=js&"
import style0 from "./BanksPage.vue?vue&type=style&index=0&id=211475cc&prod&lang=css&scoped=true&"
import style1 from "./BanksPage.vue?vue&type=style&index=1&id=211475cc&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211475cc",
  null
  
)

export default component.exports